import { FormattedMessage } from 'react-intl'
import { useApolloClient } from '@apollo/client'
import styled from 'styled-components'

import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import { resolvers as loginResolvers } from 'resolvers/login'
import { getDefaultFare } from 'resolvers/fares'

const StyledTh = styled(Th)<TSFixMe>`
  ${(props): TSFixMe => {
    if (props.isFirstElementActive) {
      return `
        border-bottom: none;
      `
    }
  }}
`

const StyledTr = styled(Tr)<TSFixMe>`
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.3);

  :nth-child(even) {
    background-color: rgba(230, 230, 230, 0.3);
  }

  ${(props): TSFixMe => {
    if (props.isActive) {
      return `
        background-color: #ecf4ff!important;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.19);
        border: solid 2px #207eff;
      `
    }
  }}
`

const SegmentCell = styled(Td)<TSFixMe>`
  white-space: nowrap;
`

const CompanyCell = styled(Td)<TSFixMe>`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100px;
`

export const FareFamiliesList = ({ fareFamilies = [], activeFamilyIndex, setActiveFamilyIndex }: TSFixMe): TSFixMe => {
  const client = useApolloClient()
  client.addResolvers(loginResolvers)

  return (
    <TableContainer>
      <Table>
        <Thead>
          <Tr>
            <StyledTh isFirstElementActive={activeFamilyIndex === 0}>
              <FormattedMessage id="dictionary.segment" defaultMessage="Segment" />
            </StyledTh>

            <StyledTh isFirstElementActive={activeFamilyIndex === 0}>
              <FormattedMessage id="dictionary.family" defaultMessage="Family" />
            </StyledTh>

            <StyledTh isFirstElementActive={activeFamilyIndex === 0}>
              <FormattedMessage id="dictionary.company" defaultMessage="Company" />
            </StyledTh>

            <StyledTh isFirstElementActive={activeFamilyIndex === 0}>
              <FormattedMessage id="fareFamiles.list.defaultBase" defaultMessage="Default base" />
            </StyledTh>

            <StyledTh isFirstElementActive={activeFamilyIndex === 0}>
              <FormattedMessage id="fareFamiles.list.fareBase" defaultMessage="Fare base" />
            </StyledTh>

            <StyledTh isFirstElementActive={activeFamilyIndex === 0}>
              <FormattedMessage id="fareFamiles.list.count" defaultMessage="Count" />
            </StyledTh>
          </Tr>
        </Thead>

        <Tbody>
          {fareFamilies.map((fareFamily: TSFixMe, index: number): TSFixMe => {
            const { segment, familyName, company, fares } = fareFamily
            const defaultFare = getDefaultFare(fares)

            return (
              <StyledTr
                key={fareFamily.id}
                isActive={activeFamilyIndex === index}
                onClick={(): TSFixMe => setActiveFamilyIndex(index)}
              >
                <SegmentCell>
                  {segment.origin.code} - {segment.destination.code}
                </SegmentCell>

                <Td>{familyName}</Td>

                <CompanyCell>{company.name}</CompanyCell>

                <Td>{defaultFare && `${defaultFare.bookingClass.name}${defaultFare.type}`}</Td>

                <Td>{defaultFare && <FormattedPrice value={defaultFare.basePrice} />}</Td>

                <Td>{fares.length}</Td>
              </StyledTr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
